import React from 'react';

const Card = ({ children, className = '', title }) => {
  return (
    <div className={className || 'card'}>
      {title && <h2>{title}</h2>}
      {children}
    </div>
  );
};

export default Card;
